"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ScimToken", {
    enumerable: true,
    get: function() {
        return ScimToken;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ScimToken = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    last_used_at: _zod.z.date().or(_zod.z.null()),
    deleted_at: _zod.z.date().or(_zod.z.null()),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    created_by: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    token: _zod.z.string(),
    enabled: _zod.z.boolean(),
    manager_sync_enabled: _zod.z.boolean()
});
